var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-items"},_vm._l((_vm.mixedOrderItems),function(ref,index){
var id = ref.id;
var orderIndex = ref.orderIndex;
var item = ref.item;
var isSubscription = ref.isSubscription;
return _c('OrderItem',{key:id,attrs:{"id":id,"item":item,"orderIndex":orderIndex,"isStockIgnored":_vm.ignoreStock,"sizeModifier":_vm.sizeModifier,"isMerging":_vm.mergedItemIndex === index,"isTransitioning":_vm.isTransitioning,"isReadOnly":_vm.readOnly,"isShowingFullGiftCardMsg":_vm.showFullGiftCardMsg,"isSubscriptionItem":isSubscription,"onRemoveItemFromCart":_vm.onRemoveItemFromCart}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }